/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unused-vars */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import * as React from 'react';
import {
  Grid,
  Container,
  Popover,
  Box,
  Typography,
  Button,
  IconButton,
  List,
  ListItem,
  Divider,
  Link,
} from '@mui/material';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

import boxIconImg from '../../../../assets/images/BoxIcon.png';
import uploadPhotoImg from '../../../../assets/images/UploadPhoto.png';
import tileData from '../../../../data/tile.data';

import './SelectTile.styles.css';
import { setCustomTile, setSelectedTile, reset } from '../../../../store/tile.slice';
import { useAppDispatch } from '../../../../store/hooks';
import { useNavigate } from 'react-router-dom';

const TileSelection = () => {
  // Start Account Setting Code
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(reset());
  }, [dispatch]);

  const handleChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = (event.target as HTMLInputElement).files?.[0];

    // Check if a file is selected
    if (!file) {
      alert('No file selected.');
      return;
    }

    // Create a FileReader object to read the file
    const reader = new FileReader();

    // Set up the FileReader onload event
    reader.onload = function (event) {
      const img = new Image();

      // Set up the onload event for the image
      img.onload = function () {
        // Create a canvas element
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Calculate the new width and height for the compressed image
        const maxWidth = 400;
        const maxHeight = 400;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }

        // Set the canvas dimensions to the new image dimensions
        canvas.width = width;
        canvas.height = height;

        // Draw the image on the canvas
        ctx.drawImage(img, 0, 0, width, height);

        // Get the base64 data URL of the compressed image
        const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.7);
        dispatch(setCustomTile(compressedDataUrl));
        navigate('../visualizer/edit-tile');
      };

      // Set the source of the image with the file data
      img.src = event.target.result;
    };

    // Read the file as a data URL
    reader.readAsDataURL(file);
  };

  const opensecond = Boolean(anchorEl);
  const id = opensecond ? 'simple-popover' : undefined;
  // End Account Setting Code
  return (
    <Grid container direction="row">
      <Grid size={12}>
        <Grid container direction="row" columnSpacing={4} className="GridRow LightSkyBlue">
          <Grid size={12}>
            <Box className="BannerTitle TileBannerTitle LeftAlign">
              <img src={boxIconImg} alt="Box Icon" />
              <Typography variant="h1" className="">
                Getting Started
              </Typography>
            </Box>
            <Box className="Subtitle">
              <Typography variant="body2">Add your tile using one of the options below</Typography>
            </Box>
            <Box className="PhotoInfo">
              <Typography variant="h5">
                <b>For Best Photo Results</b>
              </Typography>
              <List className="CustomList">
                <ListItem>Ensure the tile surface is properly lit</ListItem>
                <ListItem>To minimize distortion, try not to take the photo at an angle</ListItem>
              </List>
            </Box>
          </Grid>
        </Grid>
        <Grid container direction="row" columnSpacing={0} className="GridRow">
          <Grid size={12}>
            <Box sx={{ mb: 4 }}>
              <Button
                variant="outlined"
                aria-describedby={id}
                onClick={handleClick}
                className="AddYourPhotoBox"
                style={{
                  backgroundImage: `url(
                      ${tileData[0].src}
                    )`,
                }}
              >
                <Box component="div" className="AddYourPhotoInner">
                  <Box>
                    <IconButton>
                      <CameraAltOutlinedIcon color="primary" />
                    </IconButton>
                    <Typography variant="h6">Add Your Own</Typography>
                  </Box>
                </Box>
              </Button>
            </Box>
            <Popover
              id={id}
              open={opensecond}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              className="OptionsPopover"
            >
              <Box className="OptionsPopoverBox">
                <List>
                  <ListItem className="TakePhoto">
                    <Link onClick={() => navigate('../visualizer/capture-tile')}>
                      <CameraAltIcon /> Take Photo
                    </Link>
                  </ListItem>
                  <Divider className="CustomDivider"></Divider>
                  <label htmlFor="formId">
                    <ListItem>
                      <Link>
                        <input
                          name=""
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={handleChangeFile}
                          id="formId"
                          hidden
                        />
                        <img src={uploadPhotoImg} alt="Box Icon" />
                        <span>Upload Photo</span>
                      </Link>
                    </ListItem>
                  </label>
                </List>
              </Box>
            </Popover>
          </Grid>
          <Grid size={12}>
            <Container maxWidth="sm" disableGutters>
              <Box sx={{ mb: 4 }}>
                <Divider></Divider>
              </Box>
              <Grid container direction="row" columnSpacing={0} className="DefaultTileContainer">
                <Grid size={12}>
                  <Box className="DefaultTileContent">
                    {tileData.map((tile) => (
                      <Button
                        onClick={() => {
                          dispatch(setSelectedTile(tile.src));
                          navigate('../visualizer/configure-tile');
                        }}
                        key={tile.name}
                        variant="outlined"
                        className="DefaultTile"
                        style={{
                          backgroundImage: `url(
                      ${tile.src}
                    )`,
                        }}
                      />
                    ))}
                  </Box>
                </Grid>
              </Grid>
              <Box sx={{ mt: 3 }}>
                <Divider></Divider>
              </Box>
            </Container>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TileSelection;
